import { FC } from 'react'
import { Icon } from '@iconify/react'

import s from './EmptyStateCard.module.css'

type Props = {
  alt: string
  image: string
  title: string
  icon: React.ReactElement
  onClick: () => void
  subTitle?: string
  description?: string
  disabled?: boolean
  dataId?: string
}

export const EmptyStateCard: FC<Props> = ({
  image,
  alt,
  title,
  subTitle,
  description,
  icon,
  onClick,
  disabled,
  dataId,
}) => {
  return (
    <button
      className={s.wrapper}
      onClick={onClick}
      disabled={disabled}
      data-id={dataId}
    >
      <img src={image} alt={alt} className={s.image} />
      <div className={s.details}>
        <div className={s.footer}>
          <div>
            <div className={s.title}>
              {title} <Icon icon="lucide:arrow-right" />
            </div>
            {subTitle && <span className={s.subtitle}>{subTitle}:</span>}
            <span className={s.description}>{description}</span>
          </div>
          <div className={s.iconWrapper}>{icon}</div>
        </div>
      </div>
    </button>
  )
}
